import { useEffect, useState } from 'react';
import EventQnASection from './EventQnASection';
import EditEventForm from './EditEventForm';
import EventView from '../EventView';

const API = process.env.REACT_APP_API_URL || '';

/**
 * Wrapper that fetches event by ID and renders EventView. Used for /event/show/:eventId route.
 */
export function EventShowPage({ eventId, user }) {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!eventId) return;
    setLoading(true);
    setError(null);
    fetch(`${API}/api/events/${eventId}?requesterUserId=${encodeURIComponent(user?.id || '')}`)
      .then((res) => {
        if (!res.ok) {
          setEvent(null);
          setError('Event not found');
          setLoading(false);
          return;
        }
        return res.json();
      })
      .then((data) => {
        if (data && !data.error) {
          setEvent(data);
        }
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load event');
        setLoading(false);
      });
  }, [eventId, user?.id]);

  if (loading) {
    return (
      <div className="App-block">
        <p>Loading event...</p>
      </div>
    );
  }
  if (error || !event) {
    return (
      <div className="App-block">
        <p>{error || 'Event not found.'}</p>
        <button type="button" className="Button" onClick={() => { window.location.href = '/'; }}>
          Takaisin
        </button>
      </div>
    );
  }
  return (
    <EventView
      event={event}
      user={user}
      onBack={() => { window.location.href = '/'; }}
    />
  );
}

/**
 * Wrapper that fetches event by ID and renders EditEventView. Used for /event/edit/:eventId route.
 */
export function EditEventPage({ eventId, user }) {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!eventId) return;
    setLoading(true);
    setError(null);
    fetch(`${API}/api/events/${eventId}?requesterUserId=${encodeURIComponent(user?.id || '')}`)
      .then((res) => {
        if (!res.ok) {
          setEvent(null);
          setError('Event not found');
          setLoading(false);
          return;
        }
        return res.json();
      })
      .then((data) => {
        if (data && !data.error) {
          setEvent(data);
        }
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load event');
        setLoading(false);
      });
  }, [eventId, user?.id]);

  if (loading) {
    return (
      <div className="App-block">
        <p>Loading event...</p>
      </div>
    );
  }
  if (error || !event) {
    return (
      <div className="App-block">
        <p>{error || 'Event not found.'}</p>
        <button type="button" className="Button" onClick={() => { window.location.href = '/'; }}>
          ←
        </button>
      </div>
    );
  }
  return (
    <EditEventView
      event={event}
      user={user}
      onCancel={() => { window.location.href = '/'; }}
      onSaved={() => { window.location.href = '/'; }}
    />
  );
}

function EditEventView({ event: initialEvent, user, onCancel, onSaved }) {
  const matchesByUserId =
    initialEvent?.createdByUserId != null && String(initialEvent.createdByUserId) === String(user?.id);
  const matchesByAuthorName =
    initialEvent?.author === (user?.displayName || user?.username);
  const isAuthor = user && (matchesByUserId || matchesByAuthorName);

  const handleReturn = () => {
    if (typeof onCancel === 'function') {
      onCancel();
    } else {
      window.location.href = '/';
    }
  };

  if (!initialEvent) return null;

  return (
    <div className="EditEvent App-block">
      <div className="EditEvent-header-actions">
        <button
          type="button"
          className="EditEvent-back"
          onClick={handleReturn}
        >
          ←
        </button>
      </div>

      {isAuthor ? (
        <EditEventForm
          event={initialEvent}
          user={user}
          onCancel={onCancel}
          onSaved={onSaved}
        />
      ) : (
        <EventView
          event={initialEvent}
          user={user}
          onBack={handleReturn}
        />
      )}

      <EventQnASection event={initialEvent} user={user} />
    </div>
  );
}

export default EditEventView;
